import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

const {
  grid: { resolution, spacing },
  primaryColours,
} = theme

export const IntroductoryNcdModalStyle = styled.div`
  .modal-info-container {
    margin: ${spacing.base}px 0;
    .modal-info {
      color: ${primaryColours.aubergine.main};
    }
    .radio-wrapper {
      margin: ${spacing.s}px 0;
    }
  }
  .dropdown-wrapper {
    margin-top: ${spacing.s}px;
  }
  .attribute-box {
    .attribute-container {
      margin-top: 0;
    }
    h5 {
      display: none;
    }
  }
  .ncd-banner {
    margin-top: ${spacing.base}px;
  }
  .ncd-bonus-container {
    max-width: 390px;
    .internal {
      align-items: flex-start;
    }
  }
  .ncd-discount-text-bold {
    font-weight: 700;
  }
  .ncd-discount-text {
    margin-bottom: ${spacing.xs}px;
  }
  @media (min-width: ${resolution.tablet.width}px) {
    .modal-info-container {
      margin: ${spacing.md}px 0;
    }
  }
  @media (max-width: ${resolution.tablet.width}px) {
    .ncd-bonus-container {
      max-width: 280px;
    }
  }
`
